module.exports = __webpack_public_path__ + "img/jam-sessions-side.51cae112.png";